export default "__VITE_ASSET__DwDIG3W8__"